const ku = {
  ku1: { name: 'Verkaufen', desc: 'z.B. Waren, Dienstleistungen', },
  ku2: { name: 'Leiten', desc: 'z.B. Mitarbeiter, Auszubildende', },
  ku3: { name: 'Verhandeln', desc: 'z.B. Preise, Verträge', },
  ku4: { name: 'Organisieren', desc: 'z.B. Veranstaltungen, Arbeitstreffen', },
  ku5: { name: 'Entwickeln', desc: 'z.B. Verkaufsstrategien, Produktideen', },
  ku6: { name: 'Entscheiden', desc: 'z.B. Personaleinstellungen, Ein- und Verkäufe', },
  ku7: { name: 'Kontrollieren', desc: 'z.B. Verkaufsergebnisse, Kontoeingänge', },
  ku8: { name: 'Werben', desc: 'z.B. für Angebote, neue Produkte', },
  ku9: { name: 'Vermarkten', desc: 'z.B. Häuser, Wohnungen, Versicherungen', },
  ku10: { name: 'Prüfen', desc: 'z.B. Betriebsergebnisse, Abrechnungen', },
}

export default ku
